import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HistoricoAgendamento, HistoricoAtendimento, HistoricoBuscaPaciente, HistoricoCupom, HistoricoNotaFiscal, HistoricoOrcamentoLinha, HistoricoPlano } from '../../interfaces/historico-paciente';

/** Histórico do Paciente (portado do sim-relatorios). Datas em yyyy-MM-dd. */
@Injectable({ providedIn: 'root' })
export class HistoricoPacienteService {
  private apiURL = `${environment.apiUrl}/v${environment.apiVersion}/HistoricoPaciente`;

  constructor(private httpClient: HttpClient) {}

  /** Nome, CPF, código do cliente ou número do atendimento. */
  buscar(termo: string): Promise<HistoricoBuscaPaciente[]> {
    return this.lista(`buscar?q=${encodeURIComponent(termo)}`);
  }

  agendamentos(cdPessoaFisica: number): Promise<HistoricoAgendamento[]> {
    return this.lista(`agendamentos?cdPessoaFisica=${cdPessoaFisica}`);
  }

  atendimentos(cdPessoaFisica: number): Promise<HistoricoAtendimento[]> {
    return this.lista(`atendimentos?cdPessoaFisica=${cdPessoaFisica}`);
  }

  orcamentos(cdPessoaFisica: number): Promise<HistoricoOrcamentoLinha[]> {
    return this.lista(`orcamentos?cdPessoaFisica=${cdPessoaFisica}`);
  }

  notasFiscaisPaciente(cdPessoaFisica: number): Promise<HistoricoNotaFiscal[]> {
    return this.lista(`notas-fiscais-paciente/${cdPessoaFisica}`);
  }

  async plano(cdPessoaFisica: number): Promise<HistoricoPlano | null> {
    return (await this.lista<HistoricoPlano>(`plano/${cdPessoaFisica}`))[0] ?? null;
  }

  cupons(cdPessoaFisica: number): Promise<HistoricoCupom[]> {
    return this.lista(`cupons/${cdPessoaFisica}`);
  }

  notasFiscais(nrAtendimento: number): Promise<HistoricoNotaFiscal[]> {
    return this.lista(`notas-fiscais/${nrAtendimento}`);
  }

  // O back responde 404 para lista vazia; so os outros erros sobem.
  private async lista<T>(caminho: string): Promise<T[]> {
    try {
      const r = await firstValueFrom(this.httpClient.get<any>(`${this.apiURL}/${caminho}`));
      return r?.data ?? [];
    } catch (e) {
      if (e instanceof HttpErrorResponse && e.status === 404) return [];
      throw e;
    }
  }
}
